import ApplicationState from "./ApplicationState";
/**
 * Форматирование числа в удобную для восприятия человеком форму
 *
 * @param any value
 * @param int decimal - число знаков после точки
 *
 * @returns string
 */
export function numberFormat(value: any, decimal: number = 0): string {
    return Number(value).toFixed(decimal).replace(/\d(?=(\d{3})+($|\.))/g, '$& ');
}

/**
 * Следующий соседний элемент
 * @param {Element} target         - элемент, относительно которого осуществляется поиск
 * @param {boolean} ignoreTextNode - не учитывать текстовые узлы при поиске. По умолчанию true
 * @returns {Element|null}
 */
export function nextSibling(target: Element, ignoreTextNode: boolean = true): Element|null
{
    let sibling  = null;

    if (typeof target.nextElementSibling !== 'undefined') {
        sibling = target.nextElementSibling;
    } else {
        while (sibling === null && target.nextSibling !== null) {
            if (!ignoreTextNode || target.nextSibling.nodeName !== '#text') {
                sibling = target.nextSibling;
            }
        }
    }

    return sibling;
}

/**
 * Аналогия insertBefore
 * @param {Element} target - элемент, который необходимо вставить
 * @param {Element} parent - родительский элемент
 * @param {Element} after  - элемент, после которого необходимо разместить target
 */
export function insertAfter(target: Element, parent: Element, after: Element = null)
{
    let before = after === null ? null : nextSibling(after);

    if (before === null) {
        parent.appendChild(target);
    } else {
        parent.insertBefore(target, before);
    }
}

/**
 * Вернет абсолютный URL
 * 
 * @param {string} url 
 * @returns {string}
 */
export function prepareUrl(url: string): string
{
    url = url.trim();
    
    // слеш в начале урла, если нет хоста
    if (url[0] !== '/' && url.search('://') === -1) {
        url = '/' + url;
    }

    // слеш в конце урла, если нет get-параметров
    if (url[url.length - 1] !== '/' && url.search('\\?') === -1) {
        url += '/';
    }

    return url;
}

/**
 * Поиск родительского элемента по вхождению класса
 * 
 * @param {Element} target - элемент, для которого нужно найти родителя
 * @param {string}  htmlClass - HTML класс, нахождение которого останавливает поиск родителя
 * @returns {Element|null}
 */
export function getParentByClass(target: Element, htmlClass: string): Element|null
{
    do {
        target = target.parentElement;
    } while (target !== null && !target.classList.contains(htmlClass));

    return target;
}

/**
 * Клонирование простых объектов
 * @param {object} o 
 * @returns object
 */
export function cloneObject(o: object): object
{
    return Object.assign({}, o);
}

export function isset(value: any): boolean
{
    return typeof value !== 'undefined';
}

export function setSessionParam(name: string, value: string): Promise<void>
{
    let data = new FormData;

    data.append('key', name);
    data.append('value', value);

    return ApplicationState.axios.post('/api/set_session_param/', data);
}
